import React, { Component, Fragment } from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Immocom } from '../../specifique/immocom';
import Scriba from 'react-scriba';


export const BlocReservation = (props) => {
    const { title, afficheEditButton, onEdit, afficheSeparationPiedDeBloc, children } = props;
    //const nbItems = children.length;
    return (
        <Fragment>
            <div className="ms-Grid-row px-2">
                {afficheEditButton && (
                    <div className="boutonEditionBlocReservation">
                        <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" ariaLabel="Modifier" onClick={onEdit} />
                    </div>
                )}
            </div>
            { title && (<div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 titreBlocReservation">{title}</div>)}            
            {children}
            <div>
                {afficheSeparationPiedDeBloc && (<div className="ms-Grid-row px-2"><hr /></div>)}
            </div>
        </Fragment>
    )
}